import { getString } from "../common/common";

export const SELECT_BOARDING_POINT = "SELECT_BOARDING_POINT";
export const SELECT_DROPPING_POINT = "SELECT_DROPPING_POINT";
export const CANCEL = "CANCEL";
export const MODIFY = "MODIFY";
export const BOOKING_MODIFIED = "BOOKING_MODIFIED";
export const PICKUP_DROPOFF = "PICKUP_DROPOFF";
export const SAVED_SUCCESSFULLY = "SAVED_SUCCESSFULLY";
export const MODIFICATION_FAILED = "MODIFICATION_FAILED";
export const THE_TICKET_NON_EDITABLE = "THE_TICKET_NON_EDITABLE";
export const GO_BACK_TO_HOME = "GO_BACK_TO_HOME";

export const translations = {
  en: {
    [SELECT_BOARDING_POINT]: "Select Boarding Point",
    [SELECT_DROPPING_POINT]: "Select Dropping Point",
    [CANCEL]: "Cancel",
    [MODIFY]: "Modify",
    [BOOKING_MODIFIED]: "Booking Modified",
    [PICKUP_DROPOFF]: "Pickup & Dropoff",
    [SAVED_SUCCESSFULLY]: "Saved Successfully",
    [MODIFICATION_FAILED]: "Modification Failed",
    [THE_TICKET_NON_EDITABLE]: "The ticket is non editable",
    [GO_BACK_TO_HOME]: "Go Back Home",
  },
  kn: {
    [SELECT_BOARDING_POINT]: "ಹತ್ತುವ ಸ್ಥಳಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
    [SELECT_DROPPING_POINT]: "ಇಳಿಯುವ ಸ್ಥಳಗಳನ್ನು ಆಯ್ಕೆ ಮಾಡಿ",
    [CANCEL]: "ರದ್ದುಮಾಡು",
    [MODIFY]: "ಮಾರ್ಪಡಿಸಿ",
    [BOOKING_MODIFIED]: "ಬುಕಿಂಗ್ ಮಾರ್ಪಡಿಸಲಾಗಿದೆ",
    [PICKUP_DROPOFF]: "ಪಿಕಪ್ ಮತ್ತು ಡ್ರಾಪ್ಆಫ್",
    [SAVED_SUCCESSFULLY]: "ಯಶಸ್ವಿಯಾಗಿ ಸೇವ್ ಮಾಡಲಾಗಿದೆ ",
    [MODIFICATION_FAILED]: "ಮಾರ್ಪಾಡು ವಿಫಲವಾಗಿದೆ",
    [THE_TICKET_NON_EDITABLE]: "ಟಿಕೆಟ್ ಎಡಿಟ್ ಮಾಡಲು ಸಾಧ್ಯವಿಲ್ಲ",
    [GO_BACK_TO_HOME]: "ಹೋಂ ಗೆ ಹಿಂತಿರುಗಿ",
  },
};

export const t = (key = "") => {
  return getString(key, translations);
};
